module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921035334_T.41875683.jpg";